import React from 'react'
import { func, string, shape } from 'prop-types'
import { translate } from 'react-i18next'

export const QuotationButtons = translate()(({ proposal, t }) => {
  if (!proposal || !proposal.quotation) {
    return (<span />)
  }
  return (
    <div>
      <a className='btn--green' target='_blank' href={proposal.quotation.path}>{t('common:visits:read_invoice')}</a>
      <a className='btn--green' target='_blank' href={proposal.quotation.path + '&download=true'}>{t('common:visits:download_invoice')}</a>
    </div>
  )
})

QuotationButtons.propTypes = {
  t: func,
  proposal: shape({
    quotation: shape({
      path: string
    })
  })
}


// WEBPACK FOOTER //
// ./src/components/ui/buttons/QuotationButtons.js